import { format } from 'date-fns';

export const formatDate = (iso: string | Date) => {
  return format(iso, DEFAULT_FORMAT_DATE_STR);
};

export const DEFAULT_FORMAT_DATE_STR = 'dd MMM yyyy, HH:mm';
